import { getHideStatistics } from 'shared/utils';
const { licenses } = getHideStatistics();
import i18n from 'i18nextInstance';

export const HEADERS = [{
    flex: 3,
    key: 'name',
    label: i18n.t('Diagnóstico')
}, {
    key: 'total',
    label: i18n.t('Cantidad')
}, {
    key: 'percentage',
    label: i18n.t('Porcentaje')
}, {
    hidden: licenses,
    key: 'avg_days',
    label: i18n.t('Licencia promedio')
}, {
    key: 'confirmed',
    label: i18n.t('Confirmado')
}, {
    key: 'presumptives',
    label: i18n.t('Presuntivo')
}];
